export const COLOR_SCHEME_STORAGE_KEY = 'ywc-color-scheme';

/** Fired on `window` after every `applyColorScheme` so multiple toggles stay in sync. */
export const COLOR_SCHEME_APPLIED_EVENT = 'ywc-color-scheme-applied';

export type ColorScheme = 'light' | 'dark';

export function getStoredColorScheme(): ColorScheme | null {
  const v = localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);
  if (v === 'light' || v === 'dark') {
    return v;
  }
  return null;
}

export function getSystemColorScheme(): ColorScheme {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getEffectiveColorScheme(): ColorScheme {
  return getStoredColorScheme() ?? getSystemColorScheme();
}

export function applyColorScheme(scheme: ColorScheme, persist: boolean): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', scheme);
  root.classList.remove('sl-theme-light', 'sl-theme-dark');
  root.classList.add(scheme === 'light' ? 'sl-theme-light' : 'sl-theme-dark');
  if (persist) {
    localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, scheme);
  }
  const meta = document.getElementById('theme-color-meta') as HTMLMetaElement | null;
  if (meta) {
    meta.content = scheme === 'light' ? '#FEF8EE' : '#013C6C';
  }
  window.dispatchEvent(
    new CustomEvent(COLOR_SCHEME_APPLIED_EVENT, { detail: { scheme }, bubbles: true, composed: true })
  );
}

export function toggleStoredColorScheme(): ColorScheme {
  const next: ColorScheme = getEffectiveColorScheme() === 'light' ? 'dark' : 'light';
  applyColorScheme(next, true);
  return next;
}
